import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import desktopImageWebp from './images/environment-hero-desktop.webp';
import mobileImageWebp from './images/environment-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => (
  <HeroSectionStyled
    sectionId='sustainability-impact-environment-hero'
    productName='Sustainability and Impact'
    headingText={<>Reducing our <WidowBlock>environmental impact.</WidowBlock></>}
    descriptionText='We implement environmentally sensitive practices, caring for people and planet.'
    ctaPrimary={{
      linkUrl: '/assets/pdf/sustainability/2024-sustainability-and-impact-report.pdf',
      buttonText: 'Read the report',
      ariaLabel: 'Read the sustainability and social impact report.',
      isInternalPdf: true,
      children: '',
    }}
    backgroundImageAriaLabel='A view of the Northwestern Mutual downtown Milwaukee campus from the ground as people walk by'
    backgroundImageDesktop={desktopImageWebp.toString()}
    backgroundImageMobile={mobileImageWebp.toString()}
    backgroundImageDesktopLowRes={lowResImageDesktop}
    backgroundImageMobileLowRes={lowResImageMobile}
    backgroundVariant='lightB'
    themeType='lightTheme'
  />
);
